import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Form } from "semantic-ui-react";
import { PdApiActions, pdApiActions } from "../../../actions/pdApiActions";
import DropdownField from "../../../components/Editing/DropdownField";
import {
  getKceVersionOptions,
  getKceProductOptions,
  getDriveVersionOptions,
  getEscalatorVersionOptions
} from "../../../utils/pdApiUtils";

type StateProps = {
  filterOptions: State.FilterOptions;
  pdApi: State.PdApi;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};
type OwnProps = {
  filterTarget: string;
};

export type VersionFilterProps = StateProps & DispatchProps & OwnProps;

export class ProductVersionFilter extends React.Component<VersionFilterProps> {
  render(): JSX.Element {
    const { pdApi, filterOptions, filterTarget } = this.props;
    const kceVersionOptions =
      filterTarget === "kceVersion" || filterTarget === "apmVersion"
        ? getKceVersionOptions(pdApi.kceVersions)
        : [];
    const kceProductOptions =
      filterTarget === "kceProduct" || filterTarget === "apmProduct"
        ? getKceProductOptions(pdApi.kceProducts)
        : [];
    const driveVersionOptions =
      filterTarget === "driveVersion"
        ? getDriveVersionOptions(pdApi.domains, pdApi.driveVersions)
        : [];
    const escalatorVersionOptions =
      filterTarget === "escalatorVersion"
        ? getEscalatorVersionOptions(pdApi.domains, pdApi.EscalatorVersions)
        : [];

    return (
      <Form className="filterForm">
        {filterTarget === "kceVersion" && (
          <DropdownField
            id="kceVersionFilter"
            label="Version"
            value={filterOptions.selectedKceVersion}
            options={kceVersionOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedKceVersion: id
              });
            }}
          />
        )}
        {filterTarget === "driveVersion" && (
          <DropdownField
            id="driveVersionFilter"
            label="Version"
            value={filterOptions.selectedDriveVersion}
            options={driveVersionOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedDriveVersion: id
              });
            }}
          />
        )}
        {filterTarget === "escalatorVersion" && (
          <DropdownField
            id="escalatorVersionFilter"
            label="Version"
            value={filterOptions.selectedEscalatorVersion}
            options={escalatorVersionOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedEscalatorVersion: id
              });
            }}
          />
        )}
        {filterTarget === "apmVersion" && (
          <DropdownField
            id="apmVersionFilter"
            label="Version"
            value={filterOptions.selectedApmVersion}
            options={kceVersionOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedApmVersion: id
              });
            }}
          />
        )}
        {filterTarget === "kceProduct" && (
          <DropdownField
            id="kceProductFilter"
            label="Product"
            value={filterOptions.selectedKceProduct}
            options={kceProductOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedKceProduct: id
              });
            }}
          />
        )}
        {filterTarget === "apmProduct" && (
          <DropdownField
            id="apmProductFilter"
            label="Product"
            value={filterOptions.selectedApmProduct}
            options={kceProductOptions}
            onChange={id => {
              this.props.pdApiActions.setFilterOptions({
                ...filterOptions,
                selectedApmProduct: id
              });
            }}
          />
        )}
      </Form>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  filterOptions: state.filterOptions,
  pdApi: state.pdApi
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductVersionFilter);
